
<template>
  <div class="view">
    <div class="contact">
      <div class="form">
        <form class="left">
          <p v-html="$t('contact.left1')"></p>
          <p v-html="$t('contact.left2')"></p>
          <img src="@/assets/logo.png"/>
        </form>

        <div class="right map-responsive">
          <iframe :src="`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96791.58844897023!2d1.6099501043628903!3d44.346671622577865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12ac8a43bf677b0f%3A0x2b93a672eced646e!2s31%20Chemin%20de%20la%20Marchande%2C%2046000%20Cahors!5e0!3m2!1sen!2sfr!4v1591808984985!5m2!1sen!2sfr&hl=${$i18n.locale}`" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
      </div>
      <!-- <Parallax> -->
      <!-- <img class="gmap" src="@/assets/gmap.jpg" /> -->

      <!-- </Parallax> -->
    </div>
  </div>
</template>

<script>
// import VueRecaptcha from 'vue-recaptcha';
// @ is an alias to /src
export default {
  name: 'Contact',
  // components: {
  //   VueRecaptcha
  // },
  data () {
    return {
      name: '',
      email: '',
      message: '',
      optin: undefined,
      submitted: false,
    }
  },
  computed: {
    hasError () { return this.submitted && (this.name === '' || this.email === '' || this.message === '' || !this.optin || this.optin === undefined)}
  },
  methods: {
    submit () {
      this.submitted = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
  .map {
    width: 100vw;
    height: 500px;
    background-color: lightgreen;
    opacity: 0.5;
    @media (max-width: 900px) {
      height: 350px;
    }
    @media (max-width: 768px) {
      height: 250px;
    }
  }
  .contact {
    padding: 30px 0px 80px 0px;
    @media (max-width: 768px) {
      padding-top: 0px;
    }
  }
  .contact .form {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    flex-wrap: wrap-reverse;
    margin-top: 50px;
    text-align: left;

    @media (max-width: 500px) {
      margin-top: 10px;
    }
    .left, .right {
      flex: 1;
      padding: 0 30px;
      p {
        font-size: 22px;
      }
      @media (max-width: 375px) {
        padding: 0;
      }
    }
    @media (max-width: 375px) {
      .left {
        padding: 0 10px;
      }
    }
    // .group {
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: flex-start;
    //   align-items: flex-start;
    //   width: 100%;
    //   min-width: 320px;
    //   max-width: 550px;
    //   margin: auto;
    //   margin-bottom: 20px;

    //   label {
    //     font-weight: bold;
    //   }
    //   input, textarea {
    //     padding-left: 5px;
    //     height: 37px;
    //     min-width: 300px;
    //     width: 100%;
    //     border-radius: 3px;
    //     font-size: 15px;
    //     background-color: white;
    //     border: 1px solid lightgrey;

    //   }
    //   textarea {
    //     height: 100px;
    //     padding-top: 10px;
    //   }
    //   &.error {
    //     &.optin {
    //       color: red;
    //     }
    //     input, textarea {
    //       border-color: red;
    //     }
    //   }
    // }
    a.button {
      max-width: 200px;
      margin: 30px auto 0px auto;
    }
    // .optin {
    //   label {
    //     position: relative;
    //     input {
    //       position: absolute;
    //       top: -13px;
    //       left: -4px;
    //     }
    //     span {
    //       padding-left: 20px;
    //     }
    //     font-weight: normal;
    //     text-align: left;
    //   }
    // }
    .mentions {
      font-size: 14px;
      text-align: left;
      max-width: 550px;
      margin: auto
    }

    .right {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin: 10px;
      // height: 500px;
      min-width: 320px;
      iframe {
        background-color: #f7f7f7;
      }
    }
    .map-responsive{
        overflow:hidden;
        padding-bottom:56.25%;
        position:relative;
        height:0;
        margin-top: 0;

        @media (min-width: 1268px) {
          padding-bottom: 46%;
        }

        @media (max-width: 375px) {
          padding: 0;
          min-height: 200px;
          margin: 0;
        }
    }
    .map-responsive iframe{
        left:0;
        top:0;
        height:100%;
        max-height: 450px;
        width:100%;
        position:absolute;
    }
  }
  .gmap {
    width: 100%;
  }
  img {
    display: block;
    width: 100%;
    max-width: 350px;
    margin: 30px auto;
  }
  #captcha {
    visibility: hidden;
  }
</style>
